<!-- No provider => no block at all. Every program is in this state today (empty registry). -->
<ng-container *ngIf="provider">
  <section class="external-prefill" data-testid="external-prefill">

    <!-- Prompt. Hidden once a link is confirmed. -->
    <ng-container *ngIf="!confirmation">
      <p class="external-prefill__intro">{{ provider.introKey | translate }}</p>

      <div class="external-prefill__prompt">
        <label [attr.for]="'externalPrefillId'">{{ provider.idLabelKey | translate }}</label>
        <input
          id="externalPrefillId"
          type="text"
          class="form-control"
          data-testid="external-prefill-id"
          [placeholder]="provider.idPlaceholderKey | translate"
          [disabled]="disabled || busy"
          [(ngModel)]="externalId"
          (keyup.enter)="confirm()">
        <button
          type="button"
          class="btn btn-primary"
          data-testid="external-prefill-confirm"
          [disabled]="!canConfirm"
          (click)="confirm()">
          {{ (busy ? 'project.create.external-prefill.confirming'
                   : 'project.create.external-prefill.confirm') | translate }}
        </button>
      </div>

      <!-- Typed failure. role="alert" so it is announced, matching the form error summary. -->
      <p
        *ngIf="failureKey"
        class="external-prefill__failure"
        role="alert"
        data-testid="external-prefill-failure">
        {{ failureKey | translate }}
        <span *ngIf="failureDetail" class="external-prefill__failure-detail">{{ failureDetail }}</span>
      </p>
    </ng-container>

    <!-- Linked banner. -->
    <ng-container *ngIf="confirmation">
      <div class="external-prefill__linked" data-testid="external-prefill-linked">
        <span class="external-prefill__badge">{{ 'project.create.external-prefill.linked' | translate }}</span>
        <span class="external-prefill__external-id">{{ confirmation.externalId }}</span>
        <button
          type="button"
          class="external-prefill__clear"
          data-testid="external-prefill-clear"
          [disabled]="disabled"
          (click)="clear()">
          {{ 'project.create.external-prefill.clear' | translate }}
        </button>
      </div>

      <!-- The workflow's own card. Absent until a workflow registers one. -->
      <ng-container *ngIf="blockComponent">
        <ng-container *ngComponentOutlet="blockComponent; inputs: blockInputs ?? undefined"></ng-container>
      </ng-container>
    </ng-container>

  </section>
</ng-container>
